function trackVisit() {
  const tracker = document.querySelector("[data-visit-tracking]")
  if (!tracker) return

  tracker.remove()

  const csrfToken = document.querySelector("meta[name=csrf-token]")?.content
  if (!csrfToken) return

  const visit = {
    page: tracker.dataset.page,
    sale_id: tracker.dataset.saleId || null,
    product_id: tracker.dataset.productId || null,
  }

  fetch(tracker.dataset.url, {
    method: "POST",
    credentials: "same-origin",
    keepalive: true,
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken,
    },
    body: JSON.stringify({ visit }),
  }).catch(() => {})
}

export function initializeVisitTracking() {
  document.addEventListener("turbo:load", trackVisit)
}
